import { SET_SETTINGS } from '../types/settings';

export const setSettings = (settings = {}) => async dispatch => {
  dispatch({ type: SET_SETTINGS, payload: settings });
};
